import cerise from '../images/brands/cerise.png';
import sugar from '../images/brands/sugar.png';
import mp from '../images/brands/mp.png';
import inf from '../images/brands/inf.png';



const brands = [
    {
        "name": "Cerise Technology",
        "src": cerise,
        "alt": "interlocking black three dimensional C's"
    },
    {
        "name": "Quit Sugar",
        "src": sugar,
        "alt": "a black sprite like character with huge eyes"
    },
    {
        "name": "Minimally Processed",
        "src": mp,
        "alt": "a shadowed silhouette with circles traveling around"
    },
    {
        "name": "Instant Noodle Factory",
        "src": inf,
        "alt": "a beige poodle dog slurping from a red bowl of noodles"
    },
]

export default brands